import { formatErrorMessage } from './validate'
import { toastError } from './toast'

export function notifyApiError(error, fallbackMessage) {
  if (error && error.isHandled) return false

  const msg = formatErrorMessage(error) || fallbackMessage || '操作失败'
  toastError(msg)

  if (error) error.isHandled = true
  return true
}

